var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _linearGradient3, _path5, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ConstructionWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t0g3~sAu7wmgFcD82SWsCa",
    x1: 11.578,
    x2: 4.67,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#c16515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#bd5e15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#b75316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#af4216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t0g3~sAu7wmgFcD82SWsCa)",
    d: "M13,9H4C3.4,9,3,8.6,3,8s0.4-1,1-1h9c0.6,0,1,0.4,1,1S13.6,9,13,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M40.68,36.609l-9.639-10.812c-0.751-0.843-1.693-1.493-2.747-1.896l-7.514-2.876l-4.228-4.553 l-2.648-9.507l-2.85,0.932l1.65,10.417l4.77,7.263L16.13,38h13.051l0.65-7.687l8.334,7.734L40.68,36.609z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t0g3~sAu7wmgFcD82SWsCb",
    x1: 23.841,
    x2: 24.195,
    y1: 37.99,
    y2: 42.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t0g3~sAu7wmgFcD82SWsCb)",
    d: "M7,38h34c1.105,0,2,0.895,2,2v0c0,1.105-0.895,2-2,2H7c-1.105,0-2-0.895-2-2v0 C5,38.895,5.895,38,7,38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M1,5v5.5c0,0.315,0.148,0.611,0.4,0.8l1.953,1.464C4.031,13.274,5,12.789,5,11.941V5 c0-0.552-0.448-1-1-1H2C1.448,4,1,4.448,1,5z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t0g3~sAu7wmgFcD82SWsCc",
    x1: 27.925,
    x2: 30.113,
    y1: 9.193,
    y2: 18.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t0g3~sAu7wmgFcD82SWsCc)",
    d: "M24,14c0,2.76,2.238,5,4.998,5C31.764,19,34,16.76,34,14s-2.236-5-5.002-5 C26.238,9,24,11.24,24,14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 1.5,
    fill: "#35c1f1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M40.908,38C40.964,37.843,41,37.676,41,37.5c0-0.828-0.672-1.5-1.5-1.5S38,36.672,38,37.5 c0,0.176,0.036,0.343,0.092,0.5H40.908z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ConstructionWorker);
export default __webpack_public_path__ + "static/media/icons8-construction-worker.2e895487d6c8c51510daecc10b4e52f6.svg";
export { ForwardRef as ReactComponent };